import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ResponseData } from "../model/interface.model";

@Injectable({
  providedIn: "root"
})
export class MainService {
  endpoint: string = environment.endpoint;
  constructor(private http: HttpClient) {}

  getAccountFunds() {
    return this.http.get<ResponseData>(
      this.endpoint + "/account/get_accounts_funds"
    );
  }
}
